import { api } from './base.api.client'
import type {
  ActionSchema,
  CatalogResponse,
  ConnectorDetail,
} from '@/core/types/api.types'

export const connectorsApi = {
  catalog: (params?: { category?: string; q?: string }) =>
    api.get<CatalogResponse>('/connectors', params),

  detail: (connectorId: string) =>
    api.get<ConnectorDetail>(`/connectors/${encodeURIComponent(connectorId)}`),

  /** The action.json the form is rendered from. */
  actionSchema: (connectorId: string, actionId: string) =>
    api.get<ActionSchema>(
      `/connectors/${encodeURIComponent(connectorId)}/actions/${encodeURIComponent(actionId)}`,
    ),
}
